module.exports = __webpack_public_path__ + "static/media/nuriendin_hermosilla.25e58eb4.jpg";